import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { STUDENT_WRITING_GENRE_SCORES } from "../../student/performance/PerformanceReport";
import { formatNumber, formatNumberOneDecimal } from "../../shared/reportUtil";
import { studentPerformanceLink } from "./PerformanceReport";
import { WriterStandardScore, StandardScore } from "./ScoresFilteredByCourseViewModel";

export function GenreScoreTable(props: {
	className: string;
	courseId: number;
	writerData: WriterStandardScore[];
	classData: StandardScore;
}) {
	const studentNameTemplate = (rowData: WriterStandardScore) => {
		return (
			<Link
				className="link"
				to={studentPerformanceLink(props.courseId, rowData.writerId)}
				state={{ section: STUDENT_WRITING_GENRE_SCORES }}>
				{rowData.writerName}
			</Link>
		);
	};

	const argumentativeTemplate = (rowData: WriterStandardScore) => {
		return formatNumber(rowData.argumentativeScore);
	};

	const informativeTemplate = (rowData: WriterStandardScore) => {
		return formatNumber(rowData.informativeScore);
	};

	const narrativeTemplate = (rowData: WriterStandardScore) => {
		return formatNumber(rowData.narrativeScore);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Class" footerClassName="font-medium !text-right" />
				<Column
					footer={formatNumberOneDecimal(props.classData.argumentativeScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.informativeScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.narrativeScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.averageScore)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	const hasData = props.writerData && props.writerData.length > 0;

	return (
		<DataTable
			value={props.writerData}
			dataKey="writerId"
			loading={props.writerData == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header="Student"
				body={studentNameTemplate}
				sortable
				sortField="writerName"></Column>
			<Column
				header="Argumentative"
				body={argumentativeTemplate}
				sortable
				sortField="argumentativeScore"></Column>
			<Column
				header="Inform/Explan"
				body={informativeTemplate}
				sortable
				sortField="informativeScore"></Column>
			<Column
				header="Narrative"
				body={narrativeTemplate}
				sortable
				sortField="narrativeScore"></Column>
			<Column header="Average" field="averageScore" sortable></Column>
		</DataTable>
	);
}
